<template>
  <div
    class="
      overflow-hidden rounded-bl-xl will-change-transform
      print:break-inside-avoid-page
    "
  >
    <!-- HEADER -->
    <div
      class="
        mb-5 flex items-center gap-5 gap-y-1 rounded-bl-xl border-b
        border-gray-500
      "
    >
      <!-- Date -->
      <time
        class="
          relative flex w-fit items-center rounded-bl-lg bg-gray-500 py-2 pl-3
          pr-8 text-base font-semibold leading-none text-white
        "
        :datetime="data.date"
      >{{ dateFormatted }}</time>
      <!-- Publisher -->
      <p v-if="publisher" class="line-clamp-1 text-gray-500">
        {{ publisher }}
      </p>
    </div>

    <!-- CONTENT -->
    <div
      class="
        grid
        sm:grid-cols-3
      "
    >
      <!-- Image -->
      <div>
        <AppImage
          v-if="data.image"
          :src="data.image"

          class="h-full object-contain object-top"
        />
      </div>

      <!-- Text -->
      <div
        class="
          p-5
          sm:col-span-2
        "
      >
        <!-- TITLE -->
        <h3
          class="typo-h-3 mb-2"
          :class="{ 'line-clamp-3': isSidebar }"
        >
          {{ data.heading }}
        </h3>

        <div
          v-if="data.text"
          class="wysiwyg-only-lists"
          :class="{ 'line-clamp-[10]': isSidebar }"
          v-html="data.text"
        />

        <!-- Links -->
        <div v-if="links" class="mt-6 flex flex-wrap gap-x-3 gap-y-1">
          <template v-for="link in links">
            <AppButton
              v-if="link.link"
              :key="link.id"
              :to="link.link"
              variant="primary"
              :show-external-icon="link.isExternal"
              class="hover-focus:bg-transparent"
            >
              {{ link.link_text }}
            </AppButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object, required: true,
  },
})

const isSidebar = inject<boolean>('isSidebar', false)

const {
  t, locale, locales,
} = useI18n()

const dateFormatted = computed(() => {
  if (!props.data.date) return

  const dateObj = new Date(props.data.date)

  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }

  // Find the locale in the list of available locales by code
  const localeObj = locales.value.find(site => site.code === locale.value)

  return dateObj.toLocaleDateString(localeObj?.language || 'de-CH', options)
})

// Merge external link with other links
const links = computed(() => {
  /*
  * If the article has a external link, add it to the list of links.
  * Else add the articles url to the list of links
  */

  const link = props.data.link_external || props.data.permalink

  const linkObject = {
    link,
    link_text: t('more'),
    isExternal: !!props.data.link_external,
  }

  return [
    linkObject,
    ...(props.data.links && props.data.links.length ? props.data.links : []),
  ]
})

const publisher = computed(() => {
  if (props.data.publisher) {
    return props.data.publisher.title
  }

  return props.data.site_attributes.find(attr => attr.key === 'title')?.value
})
</script>
